import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup, Label } from 'reactstrap';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Input } from 'antd';
// Local Deps
import './NFInputGroup.scss';

const { Search } = Input;

function NFInputGroup({
  onAddonClick = () => null,
  onKeyDown = () => null,
  onChange = () => null,
  label = '',
  text = '',
  ...rest
}) {
  const suffix = text ? (
    <CloseCircleOutlined
      onClick={() => {
        const e = {
          target: {
            value: '',
          },
        };
        onChange(e);
        onAddonClick();
      }}
      style={{ color: 'rgba(0,0,0,.45)' }} />
  ) : (
    <span />
  );

  return (
    <div className="nf-input-group">
      <InputGroup>
        {label && <Label>{label}</Label>}
        <Search
          enterButton
          small
          onChange={onChange}
          onKeyDown={e => onKeyDown(e, text)}
          onSearch={() => onAddonClick(text)}
          value={text}
          suffix={suffix}
          {...rest}
        />
        {/* {addon && (
          <InputGroupAddon
            addonType={addonType}
            onClick={() => onAddonClick(text)}
          >
            {addon}
          </InputGroupAddon>
        )} */}
      </InputGroup>
    </div>
  );
}

NFInputGroup.propTypes = {
  onAddonClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  addonType: PropTypes.string,
  text: PropTypes.string,
  label: PropTypes.string,
};
NFInputGroup.defaultProps = {
  onAddonClick: () => null,
  onKeyDown: () => null,
  onChange: () => null,
  text: '',
  label: '',
  addonType: 'append',
};
export default NFInputGroup;



// WEBPACK FOOTER //
// ./src/components/FormBuilder/NFInputGroup/NFInputGroup.jsx